import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="transparent"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M10.1143 4.66667L5.72382 9.05719C5.20312 9.57789 5.20312 10.4221 5.72382 10.9428C6.24452 11.4635 7.08874 11.4635 7.60944 10.9428L11.8856 6.55228C12.927 5.51089 12.927 3.82245 11.8856 2.78105C10.8442 1.73965 9.15574 1.73965 8.11434 2.78105L3.8382 7.17157C2.2761 8.73367 2.2761 11.2663 3.8382 12.8284C5.4003 14.3905 7.93296 14.3905 9.49505 12.8284L13.6666 8.66667" />
  </svg>
);
